module.exports = __webpack_public_path__ + "static/media/Porter pic_1599745841498.cf5a2608.jpg";